import { Comment, Fragment, Text } from 'vue';

export function slotHasContent(slot, slotProps = {}) {
    if (!slot || typeof slot !== 'function') {
        return false;
    }

    const vnodes = slot(slotProps);

    return vnodes.some((vnode) => {
        if (vnode.type === Comment) {
            return false;
        }
        if (vnode.type === Text && vnode.children.trim() === '') {
            return false;
        }
        if (vnode.type === Fragment && vnode.children.length === 0) {
            return false;
        }
        return true;
    });
}
